import React, { useState } from "react";
import { convertFileSizeFormat } from "@/Contracts/Utils";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import { ZEmailThreadAttachmentProps } from "./interface";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import { EmailThreadFile } from "@/Contracts/Others/EmailThread";

/**
 *
 * @param files : list of attachment on email thread
 * @param onDownload : download attachment method
 * @returns {JSX}
 */
const ZEmailThreadMessageAttachment: React.FC<ZEmailThreadAttachmentProps> = ({
	files,
	onDownload
}) => {
	const [filesDownloading, setFilesDownloading] = useState<string[]>([]);

	const stopPropagation = (
		$event: React.MouseEvent<HTMLElement, MouseEvent>
	) => {
		$event.stopPropagation();
	};

	const downloadAttachment = async (file: EmailThreadFile) => {
		if (onDownload && !filesDownloading.includes(file.id)) {
			try {
				setFilesDownloading(prevState =>
					prevState.includes(file.id)
						? prevState
						: [...prevState, file.id]
				);
				await onDownload(file);
			} catch (error) {
				console.error(error);
			} finally {
				setFilesDownloading(prevState =>
					prevState.filter(
						filesDownloadingId => filesDownloadingId !== file.id
					)
				);
			}
		}
	};

	return (
		<>
			{files && files.length > 0 && (
				<div
					className="email-thread-message-files-list"
					onClick={stopPropagation}
				>
					{files.map((file, fileIndex) => {
						return (
							file.content_disposition !== "inline" && (
								<div
									key={`${fileIndex}-${file.id}`}
									className={`email-thread-message-file-container ${
										filesDownloading.includes(file.id) &&
										"downloading"
									}`}
								>
									<div className="email-thread-message-file">
										<Row>
											<Col
												span={24}
												className="email-thread-message-file-filename"
											>
												{file.filename || "[NO NAME]"}
											</Col>
											<Col
												span={24}
												className="email-thread-message-file-filesize-filetype-container"
											>
												<Row>
													<Col span={12}>
														<div className="email-thread-message-file-filesize">
															{file.size
																? convertFileSizeFormat(
																		file.size
																  )
																: ""}
														</div>
													</Col>
													<Col span={12}>
														<div className="email-thread-message-file-filetype">
															{file.filename
																? file.filename.substring(
																		file.filename.lastIndexOf(
																			"."
																		) + 1
																  )
																: ""}
														</div>
													</Col>
												</Row>
											</Col>
										</Row>
									</div>
									<div className="email-thread-message-file-overlay">
										<div
											className="email-thread-message-file-overlay-icon"
											onClick={() =>
												downloadAttachment(file)
											}
										>
											<ZIcon
												size="sm"
												name={
													filesDownloading.includes(
														file.id
													)
														? EIcons.LOADING
														: EIcons.DOWNLOAD
												}
											/>
										</div>
									</div>
								</div>
							)
						);
					})}
				</div>
			)}
		</>
	);
};

export default ZEmailThreadMessageAttachment;
